import { AssetPickerProvider, LinkEditorPanelProvider, RichTextViewProvider } from '@app/rich-editor'
import type { ReactNode } from 'react'
import { ImagePicker } from './image-picker'
import { LinkPanel } from './link-editor-panel'
import { RichTextView } from './rich-text-view'

/**
 * Wires the admin's implementations into the rich-editor's injection seams once for the whole app,
 * so every `BlockEditor` mount gets them: the read-only renderer (`RichTextView`), the image block's
 * picker (`ImageField` via `ImagePicker`) and the link popover (`LinkPanel`, locale-aware `Url`
 * list). Swap an implementation here — nowhere else.
 */
export function RichTextProviders({ children }: { children: ReactNode }): ReactNode {
	return (
		<RichTextViewProvider value={RichTextView}>
			<AssetPickerProvider value={ImagePicker}>
				<LinkEditorPanelProvider value={LinkPanel}>{children}</LinkEditorPanelProvider>
			</AssetPickerProvider>
		</RichTextViewProvider>
	)
}
